import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGlobalState } from "../../context/useGlobalState";
import Icon from "../../components/common/Icon";
import styles from "./Home.module.css";

const Home: React.FC = () => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;
    const navigate = useNavigate();
    const { setToken } = useGlobalState();
    const token = localStorage.getItem("token");

    useEffect(() => {
        if (token) {
            setToken(token);
        }
    }, [token, setToken]);

    const visitorFeatures: { icon: string; label: string; tint: string }[] = [
        { icon: "ic-headphones", label: t("audioguide_home"), tint: "t-green" },
        { icon: "ic-trophy", label: t("gamification"), tint: "t-amber" },
        { icon: "ic-pin", label: t("orientation"), tint: "t-blue" },
        { icon: "ic-globe", label: t("multipleLanguages"), tint: "t-violet" },
    ];

    const aiNodes: { icon: string; label: string; tint: string }[] = [
        { icon: "ic-sparkles", label: t("studioIA"), tint: "t-green" },
        { icon: "ic-book-open", label: t("ragDocs"), tint: "t-blue" },
        { icon: "ic-mic", label: t("toneOfVoice"), tint: "t-violet" },
        { icon: "ic-shield-check", label: t("verification"), tint: "t-amber" },
    ];

    return (
        <section className={styles.hero}>
            <div className={styles.heroL}>
                <span className={styles.kicker}>
                    <Icon name="ic-sparkles" />
                    {t("homeKicker")}
                </span>
                <h1>
                    {t("homeHeadlineLead")} <span className={styles.accent}>{t("homeHeadlineAccentNew")}</span>
                </h1>
                <p className={styles.heroSub}>{t("homeDescription")}</p>
                <div className={styles.heroCta}>
                    <button type="button" className="btn btn-primary btn-lg" onClick={() => navigate("/create/text")}>
                        {t("createExperience")}
                        <Icon name="ic-arrow-right" />
                    </button>
                </div>
                <div className={styles.trust}>
                    <span className={styles.trustItem}>
                        <Icon name="ic-globe" />
                        {t("trustLanguages")}
                    </span>
                    <span className={styles.trustItem}>
                        <Icon name="ic-book-open" />
                        {t("trustRag")}
                    </span>
                    <span className={styles.trustItem}>
                        <Icon name="ic-shield-check" />
                        {t("trustVerified")}
                    </span>
                </div>
            </div>

            <div className={styles.heroR}>
                <div className={styles.mod}>
                    <div className={styles.modHead}>
                        <span className={styles.modTitle}>
                            <Icon name="ic-headphones" />
                            {t("visitorSide")}
                        </span>
                        <span className={styles.badgeLive}>
                            <span className={styles.dot} />
                            {t("liveBadge")}
                        </span>
                    </div>
                    <div className={styles.mgrid}>
                        {visitorFeatures.map((feature) => (
                            <span key={feature.label} className="chip">
                                <span className={`chip-ico ${feature.tint}`}>
                                    <Icon name={feature.icon} />
                                </span>
                                {feature.label}
                            </span>
                        ))}
                    </div>
                </div>

                <div className={styles.mod}>
                    <div className={styles.modHead}>
                        <span className={styles.modTitle}>
                            <Icon name="ic-sparkles" />
                            {t("aiEngine")}
                        </span>
                        <span className={styles.wave} aria-hidden>
                            <i style={{ height: 5 }} />
                            <i style={{ height: 10 }} />
                            <i style={{ height: 16 }} />
                            <i style={{ height: 8 }} />
                            <i style={{ height: 13 }} />
                            <i style={{ height: 6 }} />
                        </span>
                    </div>
                    <div className={styles.pipe}>
                        {aiNodes.map((node) => (
                            <div key={node.label} className={styles.node}>
                                <span className={`${styles.nb} ${node.tint}`}>
                                    <Icon name={node.icon} />
                                </span>
                                <span className={styles.nl}>{node.label}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Home;
